import * as React from 'react';
import {
    Create,
    NumberInput,
    TextInput,
    SimpleForm,
    BooleanInput,
    required,
} from 'react-admin';

const req = [required()];

const EntityCreate = () => {
    return (
        <>
            {/* @ts-ignore */}
            <Create>
                <SimpleForm sx={{ maxWidth: { xl: '80%' } }}>
                    <TextInput
                        source="title"
                        isRequired
                        validate={req}
                        fullWidth
                    />
                    <NumberInput source="price" fullWidth />
                    <NumberInput source="minimum" fullWidth />
                    <TextInput
                        source="calc_note"
                        multiline
                        maxRows={10}
                        fullWidth
                    />
                    <BooleanInput source="countable" fullWidth />
                    <TextInput source="countable_label" fullWidth />
                    <NumberInput source="multiplier_1" fullWidth />
                    <NumberInput source="multiplier_2" fullWidth />
                    <TextInput source="units_label" fullWidth />
                    <TextInput
                        source="comment"
                        multiline
                        maxRows={10}
                        fullWidth
                    />
                </SimpleForm>
            </Create>
        </>
    );
};

export default EntityCreate;
